<template>
  <div>
    <div id="Loader" v-if="LoadYn">
      <div class="spinner-bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="chartArea">
      <div class="chartBox">
        <b-card
          class="w-100 h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">{{ header1 }}</h6>
          <div id="dataChartAxisX" class="graph default-border-top1"></div>
        </b-card>
      </div>
      <div class="chartBox">
        <b-card
          class="w-100 h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">{{ header2 }}</h6>
          <div id="dataChartAxisY" class="graph default-border-top1"></div>
        </b-card>
      </div>
      <div class="chartBox">
        <b-card
          class="w-100 h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">{{ header3 }}</h6>
          <div id="dataChartAxisZ" class="graph default-border-top1"></div>
        </b-card>
      </div>
    </div>
    <div class="btnGrp">
      <div class="jcfe pr20">
        <b-button
          class="full-startBtn"
          @click="cmdRealtimeData('start')"
          :disabled="btnDisabled"
          ><i class="fas fa-play"></i>시작</b-button
        >
        <b-button
          class="full-stopBtn"
          @click="cmdRealtimeData('stop')"
          :disabled="!btnDisabled"
          ><i class="fas fa-pause"></i>중지</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import utils from "../common/utils";
import moment from "moment";
import chartUtil from "../common/chartUtil";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  computed: {
    ...mapGetters([
      "getCenterBus",
      "getWebSocket",
      "getAlertOptions",
      "getConfirmOptions",
    ]),
    header1() {
      if (this.defaultInfo === null || this.defaultInfo === undefined) {
        return "X축";
      }
      return utils.isCCD(this.defaultInfo.devicetype)
        ? "Displacement (mm)"
        : "X축";
    },
    header2() {
      if (this.defaultInfo === null || this.defaultInfo === undefined) {
        return "Y축";
      }
      return utils.isCCD(this.defaultInfo.devicetype)
        ? "Sampling Rate (Hz)"
        : "Y축";
    },
    header3() {
      if (this.defaultInfo === null || this.defaultInfo === undefined) {
        return "Z축";
      }
      return utils.isCCD(this.defaultInfo.devicetype) ? "Intensity" : "Z축";
    },
  },
  props: {
    defaultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      LoadYn: false,
      btnDisabled: true,
      curTopicId: null,
      dataChart1: {
        time: [],
        x: [],
        y: [],
        z: [],
      },
      dataChartCnt: 100,
      isFirst: true,
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.reloadEvent);
    this.cmdRealtimeData("start");

    this.getCenterBus.$on("webSocketServerMessage", (param) => {
      if (param) {
        switch (param.target) {
          case "rabbitMQData":
            let data = JSON.parse(param.data);
            this.subRealtimeData(data);
            break;
          case "rabbitMQError":
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(param.data, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
            break;
        }
      }
    });
  },
  destroyed() {
    this.cmdRealtimeData("stop");
    window.removeEventListener("beforeunload", this.reloadEvent);
    this.getCenterBus.$off("webSocketServerMessage");
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    reloadEvent() {
      this.cmdRealtimeData("stop");
    },
    cmdRealtimeData(cmd) {
      if (cmd === "start") {
        this.LoadYn = true;
        this.setRealtimeData(cmd);
      } else {
        this.LoadYn = true;
        this.unSubRealtimeData();
        if (this.curTopicId) {
          this.setRealtimeData(cmd);
        }
      }
    },
    setRealtimeData(cmd) {
      var reqBody = {
        devid: this.defaultInfo.devid,
        devtype: this.defaultInfo.devtype,
        sensoridx: this.defaultInfo.sensoridx,
        command: cmd,
        mq_topic_id: cmd === "stop" ? this.curTopicId : null,
      };
      this.$http
        .post("/sensor/cmdRealtimeData", reqBody, { timeout: 10000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.LoadYn = false;
            if (cmd === "start") {
              var chartData = res.data.data;
              if (
                Object.keys(chartData).length !== 0 &&
                chartData.mq_topic_id !== undefined
              ) {
                this.btnDisabled = true;

                this.dataChart1.time = [];
                this.dataChart1.x = [];
                this.dataChart1.y = [];
                this.dataChart1.z = [];
                this.curTopicId = chartData.mq_topic_id;

                this.getWebSocket.send(
                  JSON.stringify({
                    target: "onRabbitMQData",
                    exchange: chartData.exchange,
                    topic: this.curTopicId,
                  })
                );
              } else {
                this.setAlertTitle();
                this.$bvModal
                  .msgBoxOk(
                    "해당 데이터가 존재하지 않습니다.",
                    this.getAlertOptions
                  )
                  .then((value) => {})
                  .catch((err) => {
                    console.error(err);
                  });
              }
            } else {
              this.btnDisabled = false;
              this.curTopicId = null;
            }
          } else {
            this.LoadYn = false;
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(
                utils.chkNull(res.data.error_msg, "관리자에게 문의하세요."),
                this.getAlertOptions
              )
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    drawTimeLineChart(id, param, range) {
      var data = [
        {
          x: param.x,
          y: param.y,
          name: param.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      var layout = chartUtil.setTimeLayout(id, {
        datacnt: param.x.length,
        showxaxiscnt: 4,
        showlegend: false,
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 30,
          t: 20,
          b: 30,
          pad: 0,
        },
      });
      if (param.shape !== undefined && param.shape !== null) {
        layout.shapes = [];
        for (let i = 0; i < param.shape.length; i++) {
          layout.shapes.push({
            type: "line",
            xref: "paper",
            x0: 0,
            y0: param.shape[i],
            x1: 1,
            y1: param.shape[i],
            line: {
              color: "#fff",
              width: 1,
              dash: "longdash",
            },
          });
        }
      }
      layout.xaxis.tickformat = "%H:%M:%S.%3f";
      Plotly.newPlot(id, data, layout);
    },
    subRealtimeData(data) {
      if (!data) return;
      if (!Object.keys(data).includes("data")) return;

      // data = { data: [[time, x, y, z], ...] }
      const items = data.data;
      const dataChart1 = {
        time: items.map((item) =>
          moment(item[0]).format("YYYY-MM-DD HH:mm:ss.SSS")
        ),
        x: items.map((item) => item[1]),
        y: items.map((item) => item[2]),
        z: items.map((item) => item[3]),
      };
      if (this.isFirst) {
        this.drawTimeLineChart("dataChartAxisX", {
          x: this.dataChart1.time,
          y: this.dataChart1.x,
        });
        this.drawTimeLineChart("dataChartAxisY", {
          x: this.dataChart1.time,
          y: this.dataChart1.y,
        });
        if (utils.isCCD(this.defaultInfo.devicetype)) {
          this.drawTimeLineChart("dataChartAxisZ", {
            x: this.dataChart1.time,
            y: this.dataChart1.z,
            shape: [0, 100],
          });
        } else {
          this.drawTimeLineChart("dataChartAxisZ", {
            x: this.dataChart1.time,
            y: this.dataChart1.z,
          });
        }
        this.isFirst = false;
      } else {
        this.buffer = this.buffer || { time: [], x: [], y: [], z: [] };
        this.buffer.time.push(...dataChart1.time);
        this.buffer.x.push(...dataChart1.x);
        this.buffer.y.push(...dataChart1.y);
        this.buffer.z.push(...dataChart1.z);

        const bufferSize = 20;
        if (this.buffer.time.length >= bufferSize) {
          const bufferedData = {
            time: this.buffer.time.splice(0, bufferSize),
            x: this.buffer.x.splice(0, bufferSize),
            y: this.buffer.y.splice(0, bufferSize),
            z: this.buffer.z.splice(0, bufferSize),
          };
          Plotly.extendTraces(
            "dataChartAxisX",
            { x: [bufferedData.time], y: [bufferedData.x] },
            [0],
            this.dataChartCnt
          );
          Plotly.extendTraces(
            "dataChartAxisY",
            { x: [bufferedData.time], y: [bufferedData.y] },
            [0],
            this.dataChartCnt
          );
          Plotly.extendTraces(
            "dataChartAxisZ",
            { x: [bufferedData.time], y: [bufferedData.z] },
            [0],
            this.dataChartCnt
          );
        }
      }
    },
    unSubRealtimeData() {
      this.getWebSocket.send(
        JSON.stringify({
          target: "offRabbitMQData",
          topic: this.curTopicId,
        })
      );
    },
    closeModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("ThreeAxisAccSensorDataChartModal");
      });
    },
  },
};
</script>

<style lang="scss">
#threeAxisAccsensorDataChartModal .modal-dialog {
  max-width: 1500px;
}
div.chartArea {
  height: 800px !important;
  padding: 10px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
div.chartBox {
  height: calc(33% - 5px);
  & .card {
    padding: 0 !important;
    & .card-header {
      padding: 6px 15px 8px;
      border-bottom: 1px solid #1f2327;
      & h6 {
        font-size: 15px;
        line-height: unset;
        justify-content: center;
      }
    }
    & .card-body {
      & .graph {
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/ThreeAxisAccSensorDataChartModal.vue